<template>
  <div :class="`swiper position-relative ${swiper_params.classes}`">
    <swiper-container :ref="ref_id" init="false">
      <slot name="default"></slot>
    </swiper-container>
    <button
      v-if="!hide_controls"
      type="button"
      role="navigation"
      class="btn swiper__button swiper__button__prev"
      @click="
        () =>
          $refs[ref_id].swiper.slidePrev(
            swiper_params.slide_speed || slide_speed
          )
      "
      :style="{
        'margin-left': `-${swiper_params.button_offset || 0}px`,
      }"
    >
      <vb-icon :name="'angle_left'" :size="20" class="arrow" id="prev-button">
        PREV
      </vb-icon>
    </button>
    <button
      v-if="!hide_controls"
      type="button"
      role="navigation"
      class="btn swiper__button swiper__button__next"
      @click="
        () =>
          $refs[ref_id].swiper.slideNext(
            swiper_params.slide_speed || slide_speed
          )
      "
      :style="{
        'margin-right': `-${swiper_params.button_offset || 0}px`,
      }"
    >
      <vb-icon :name="'angle_right'" :size="20" class="arrow" id="next-button">
        NEXT
      </vb-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "swiper",
  props: {
    ref_id: String,
    swiper_params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      slide_speed: 300,
      swiper_instance: {},
    };
  },
  mounted() {
    const swiper_instance = this.$refs[this.ref_id];
    Object.assign(swiper_instance, {
      slidesPerView: 1,
      loop: false,
      ...this.swiper_params,
    });
    swiper_instance.initialize();
    this.swiper_instance = swiper_instance;
    this.$emit('swiper-initialized', swiper_instance);
  },
  computed: {
    slides_count() {
      if (!this.$slots) {
        return 0;
      }
      if (!this.$slots["default"]) {
        return 0;
      }
      if (!this.$slots["default"].length) {
        return 0;
      }
      return this.$slots["default"].length;
    },
    hide_controls() {
      const { hide_controls = false, breakpoints = {} } =
        this.swiper_params || {};
      let hide_controls_for_breakpoint = false;
      if (!hide_controls && this.$refs[this.ref_id]) {
        const clientWidth = this.$refs[this.ref_id].clientWidth || 0;
        hide_controls_for_breakpoint = Object.entries(breakpoints)
          .map((entry) => ({ width: Number(entry[0]), ...entry[1] }))
          .reduce((b, breakpoint) => {
            const not_enough_slides =
              clientWidth >= breakpoint.width &&
              breakpoint.slidesPerView >= this.slides_count;
            return b || not_enough_slides;
          }, false);
      }
      return hide_controls || hide_controls_for_breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper {
  z-index: 0;
  &__button {
    position: absolute;
    padding: 7px;
    top: calc((100% - 30px) / 2);
    background-color: white;
    border-radius: 100%;
    z-index: 3;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
    &__prev {
      left: 12px;
    }

    &__next {
      right: 12px;
    }
  }
}
</style>
